import { INTEGRATION_PROVIDERS } from '@vy/types';
import { withSuspenseBoundary } from '../../../../../../components/utility/SuspenseBoundary';
import { useActivatedIntegration } from '../../../../../../hooks/use-activated-integration';
import { useXeroProducts } from '../../../../../../hooks/requests/integrations';
import { ExternalIntegrationProductSelector } from './ExternalIntegrationProductSelector';

const XeroProductSelectorInner: React.FC = () => {
  const isXeroConnected = useActivatedIntegration(INTEGRATION_PROVIDERS.xero);

  if (!isXeroConnected) {
    return null;
  }

  return (
    <ExternalIntegrationProductSelector
      provider={INTEGRATION_PROVIDERS.xero}
      label="Xero ERP ID"
      helperText="Link to your internal ERP system for tracking and reporting"
      placeholder="Select Xero Product"
      useProductsQuery={useXeroProducts}
      data-vy="plan-charge-drawer-xero-input"
    />
  );
};

const XeroProductSelectorWithSuspenseBoundary = withSuspenseBoundary(XeroProductSelectorInner);

export { XeroProductSelectorWithSuspenseBoundary as XeroProductSelector };
